<template>
  <div class="home-wrapper">
    <!-- Logo + App Icons zusammen zentriert -->
    <div class="content-section">
      <v-img src="assets/HPC-logo.png" contain width="235" height="80" class="mx-auto mb-8" />

      <v-row class="justify-center align-center" no-gutters>
        <v-hover v-for="(card, index) in cards" :key="index">
          <v-col class="ma-4 app-col" cols="auto" v-if="!card.hidden">
            <v-hover>
              <template v-slot:default="{ isHovering, props }">
                <v-card class="mx-auto square" :class="{ bounce: isBouncing[index], 'no-hover': isBouncing[index] }"
                  width="100" :style="{
                    border: true, background: isHovering ? '#0022690f' : 'white',
                  }" v-bind="props" :disabled="card.disabled">
                  <v-img height="100" width="100" :src="card.image" @click="handleClick(index)">
                  </v-img>
                </v-card>
                <span class="app-label">{{ card.label }}</span>
              </template>
            </v-hover>
          </v-col>
        </v-hover>
      </v-row>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import config from '../config.js';

export default {
  props: {
    isMobile: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      drawer: true,
      rail: true,
      isCardDisabled: true,
      activeWindow: 'home',
      selected: false,
      username: '',
      restricted: false,
      TENANT: config.QLIK_TENANT,
      QLIK_APPID_BI: config.QLIK_APPID_BI,
      QLIK_SHEETID_BI: config.QLIK_SHEETID_BI,
      QLIK_APPID_AI: config.QLIK_APPID_AI,
      QLIK_SHEETID_AI: config.QLIK_SHEETID_AI,
      QLIK_APPID_MARKETANALYZER: config.QLIK_APPID_MARKETANALYZER,
      QLIK_SHEETID_MARKETANALYZER: config.QLIK_SHEETID_MARKETANALYZER,
      cards: [
        { label: "Digital Assistant", url: '/digital-assistant', image: "../assets/Chatbot_BG.png", disabled: false, hidden: false },
        { label: "Reisenummern Dashboard", url: '/voyage-numbers', image: "../assets/Reisenummern_BG.png", disabled: false, hidden: true },
        { label: "BI Dashboard", url: '', image: "../assets/BI_BG.png", disabled: false, hidden: false },
        { label: "AI Dashboard", url: '', image: "../assets/AI_BG.png", disabled: false, hidden: false },
        { label: "Digital Twin / Simulation", url: '/digitaltriplet', image: "../assets/Simulation_BG.png", disabled: false, hidden: true },
        { label: "Market Analyzer", url: '', image: "../assets/Marketanalysis_BG.png", disabled: false, hidden: false },
        { label: "Sharepoint", url: '/sharepoint', image: "../assets/Datahistory_BG.png", disabled: false, hidden: true },
        { label: "AIS Data Analytics (Lite Version)", url: '', image: "../assets/AIS_BG.png", disabled: false, hidden: true },
      ],
      isBouncing: [],

    };
  },
  mounted() {
    this.getUser();

    const token = localStorage.getItem('token');
    const headers = {
        Authorization: `Token ${token}`
    }

    fetch(`${config.baseURL}/api/v1/qlik_urls/`, { headers })
      .then(res => res.json())
      .then(data => {
        this.cards[2].url = data.url_bi;
        this.cards[3].url = data.url_ai;
        this.cards[5].url = data.url_marketanalyzer;

        if (data.marketanalyzer_premium === true) {
          this.cards[5].label += ' (Premium Version)'
        }
        else {
          this.cards[5].label += ' (Lite Version)'
        }

        if (data.url_reisenummern !== '') {
          this.cards[1].hidden = false
          this.cards[1].url = data.url_reisenummern
        }

        if (data.url_ais !== '') {
          this.cards[7].hidden = false
          this.cards[7].url = data.url_ais
        }
      })
      .catch(error => {
        console.error(error);
      });
  },
  methods: {
    async getUser() {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('Token not found in localStorage');
      }
      const headers = {
        Authorization: `Token ${token}`
      }

      const response = await axios.get(`${config.baseURL}/api/v1/user/me/`, { headers })
      if (response.status == 200) {
        const user_json = response.data
        this.username = user_json.first_name
        this.email = user_json.email
        this.restricted = user_json.restricted === true
      }

      if (this.restricted) {
        for (let i = 1; i < this.cards.length; i++) {
          this.cards[i].disabled = true;
        }
      }

    },
    handleClick(index) {
      this.isBouncing[index] = true;
      setTimeout(() => {
        this.isBouncing[index] = false;
        //this.$router.push(this.cards[index].url);
        window.open(this.cards[index].url, "_blank");
      }, 750);
    }
  },
};
</script>

<style scoped>
.home-wrapper {
  display: flex;
  flex-direction: column;
  min-height: calc(100dvh - 48px); /* Mindestens volle Höhe minus Navbar */
  max-width: 1800px;
  margin: 0 auto;
  width: 100%;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 16px 0;
}

.content-section {
  text-align: center;
  margin-top: -80px;
}

@media (max-height: 700px) {
  .content-section {
    margin-top: 0;
  }
}

.app-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 160px; /* Feste Höhe für alle App-Icons */
}

.app-label {
  display: block;
  width: 100px;
  margin-top: 8px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.3;
  height: 34px; /* Feste Höhe für 2 Zeilen */
  color: #333;
  text-align: center;
  word-wrap: break-word;
  overflow-wrap: break-word;
  letter-spacing: 0.2px;
}

.text-color-white {
  color: white;
}

.disabled-card {
  opacity: 0.4;
  pointer-events: none;
}

.square {
  width: 100px;
  height: 100px;
  margin: 10px;
  font-size: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.55) !important;
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 28px;
  transition-property: box-shadow, transform, background;
  transition-duration: 200ms;
  transition-timing-function: ease;

  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.square:is(:hover, :focus) {
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
  transform: translateY(-10px);
  background: rgba(255, 255, 255, 0.7) !important;
}

@keyframes bounce {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}

.bounce {
  animation: bounce 0.5s ease infinite;
}

.no-hover:is(:hover, :focus) {
  transform: none;
}

.rounded-image {
  border-radius: 50%;
  border: 4px solid #002394;
  object-fit: cover;
}
</style>
